import { Component, Input, Output, EventEmitter, HostListener, ElementRef, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterLink, RouterLinkActive } from '@angular/router';
import { LucideAngularModule, MapPin, ChevronDown, ShoppingCart, Gift, Menu, X } from 'lucide-angular';
import { cities } from '../../data/mock';
import { LocalStorageService } from '../../services/local-storage.service';
import { Subscription } from 'rxjs';
import { ProductService } from '../../services/product.service';
import { ApiFactoryEndPoints } from '../../common/api-factory-end-points';
import { JwtService } from '../../services/jwt.service';
import { ToastService } from '../../services/toast.service';
import { AppConfigService } from '../../services/app-config.service';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [CommonModule, RouterLink, RouterLinkActive, LucideAngularModule],
  templateUrl: './header.component.html',
  styleUrl: './header.component.css',
})
export class HeaderComponent {
  @Input() cartCount = 0;

  cities = cities;
  selectedCity = cities[0];
  showCityDropdown = false;
  mobileMenuOpen = false;
  showSignIn: boolean = true;
  name: string;
  id: any;
  isMenuOpen = false;
  DeviceID: string;

  private onchangeStatusSubscription: Subscription;

  constructor(
    private router: Router,
    private localStorage: LocalStorageService,
    private productService: ProductService,
    private apiFactory: ApiFactoryEndPoints,
    private jwtService: JwtService,
    private toastrService: ToastService,
    private appConfig: AppConfigService
  ) {

  }

  ngOnInit() {
    if (this.showSignIn == true) {
      this.onAccountOperation();
    }

    if (this.showSignIn == false) {
      if (this.localStorage.getItem("DeviceID") == null) {
        this.DeviceID = crypto["randomUUID"]();
        this.localStorage.setItem("DeviceID", this.DeviceID);
        // console.log("DeviceID1=" + this.DeviceID);
      } else {
        this.DeviceID = this.localStorage.getItem("DeviceID");
        // console.log("DeviceID2=" + this.DeviceID);
      }

      // this.fCMMessageRegistration = new FCMMessageRegistration();
      // this.fCMMessageRegistration.deviceId = this.DeviceID;
      // this.fCMMessageRegistration.locId = 0;
      // this.fCMMessageRegistration.locCusId = JSON.parse(this.localStorage.getItem("google_email"));
      // this.fCMMessageRegistration.token = this.localStorage.getItem("FirebaseToken");
      // this.fCMMessageRegistration.deviceType = "Cus";
      // this.fCMMessageRegistration.applicationName = "CUI"
      // // console.log(this.fCMMessageRegistration);
      // this.commonService.saveFCMRegistrationData(this.apiFactory.getUsersaveTokenIdLocId, this.fCMMessageRegistration).subscribe((data: any) => {
      //   // console.log("DATA:" + data);
      // });
      // console.log(this.fCMMessageRegistration);
    }
  }

  toggleCityDropdown() {
    this.showCityDropdown = !this.showCityDropdown;
  }

  selectCity(city: string) {
    this.selectedCity = city;
    // this.showCityDropdown = false;
  }

  toggleMobileMenu() {
    this.mobileMenuOpen = !this.mobileMenuOpen;
  }
  @ViewChild('cityDropdown') cityDropdown!: ElementRef;
  @HostListener('document:click', ['$event'])
  onClickOutside(event: MouseEvent) {
    if (
      this.showCityDropdown &&
      this.cityDropdown &&
      !this.cityDropdown.nativeElement.contains(event.target)
    ) {
      this.showCityDropdown = false;
    }
  }

  loginClick() {
    this.router.navigateByUrl('/login')
  }

  onAccountOperation() {
    if (this.localStorage.getItem("google_item") != null) {
      this.name = JSON.parse(this.localStorage.getItem("google_item"));
      this.id = JSON.parse(this.localStorage.getItem("google_email"));
    }

    if (this.name != null) {
      this.showSignIn = false;
    } else if (this.name == null) {
      this.showSignIn = true;
    }
  }

  // Close menu when a link is clicked
  closeMenu() {
    this.isMenuOpen = false;
  }

  logout(isRefresh: boolean) {
    if (!window.location.href.includes('login')) {
      this.onchangeStatusSubscription = this.productService.signOutUser(this.apiFactory.signOutUser, this.jwtService.getAccessToken())
        .subscribe((data: any) => { });
    } else {
      this.toastrService.warning('Please Sign Up/Sign In Before Sign-Out');
    }
    this.jwtService.removeAccessToken();
    this.localStorage.removeItem("google_id");
    this.localStorage.removeItem("fb_id");
    this.localStorage.removeItem("google_item");
    this.localStorage.removeItem("pincode_item");
    // this.localStorage.removeItem("location_code");
    this.localStorage.removeItem("company_code");
    this.localStorage.removeItem("min_selflife");
    this.localStorage.removeItem("google_loggedIn_details");
    this.localStorage.removeItem("google_email");
    this.localStorage.removeItem("avct_item");
    this.localStorage.removeItem("avf_item");
    this.localStorage.removeItem("matrix_code");
    this.localStorage.removeItem("mto_matrix_code");
    this.localStorage.removeItem("prod_group_code");
    this.localStorage.removeItem("prod_subgroup_code");
    this.localStorage.removeItem("mto_group_code");
    this.localStorage.removeItem("mto_subgroup_code");
    this.localStorage.removeItem("orderFromTvLocation");
    this.localStorage.removeItem("web_user_info");
    this.localStorage.removeItem("signin_resp");
    this.localStorage.removeItem("facebook_signin_resp");
    this.localStorage.removeItem("filterProductItems");
    this.localStorage.removeItem("filterMtoItems");
    this.localStorage.removeItem("client_ip");
    this.name = null;
    this.onAccountOperation();
    this.router.navigate(["/"]);
    this.showSignIn = true;
    // this.isShowB2b = false;
    if (isRefresh) {
      window.location.reload();
    }
    window.location.href = this.appConfig.setting.loginLogoutUrl + "signin?cnt=1&source=" + this.appConfig.setting.logoutSource + "&target=logout";

  }
}